import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PORTFOLIO_QUERY_KEY, PORTFOLIOS_QUERY_KEY } from '../usePortfolio';
import type { PortfolioQueryClientData, Portfolio } from '../usePortfolio';

import { addHoldingsToManualPortfolioQueryFn } from './addHoldingsToManualPortfolioQueryFn';

interface Props {
  onSuccess: (portfolio: Portfolio) => void;
}

export function useAddHoldingsToManualPortfolio({ onSuccess }: Props) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: addHoldingsToManualPortfolioQueryFn,
    onSuccess: (portfolio) => {
      queryClient.setQueryData<PortfolioQueryClientData>(
        [PORTFOLIO_QUERY_KEY, portfolio.id],
        () => portfolio
      );
      onSuccess(portfolio);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: PORTFOLIOS_QUERY_KEY });
    },
  });

  return mutation;
}
